import React, { useEffect } from 'react';
import TestInstruction from '../common/testInstruction';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import {
	fetchAttempt,
	fetchInstruction,
} from '../../redux/myCourse/myCourse.actions';
import { setShowThankModal } from '../../redux/testPage/testPage.actions';
import ProductPromo from './utils/productPromo';
import ReviewAttemptModal from '../common/reviewAttemptModal';
import { setErrorMsg } from '../../redux/utilities/utils.actions';
import Config from '../../config/Config';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { tagEvent } from '../../utils/tagManager';
import { dateDiff } from '../../utils/commonFunctions';
const ThankYouModal = ({
	thanksval: {
		dailyStepImg,
		certImg,
		attemptScore,
		certLink,
		upNext,
		productPromo,
		addToLinkedin,
		score,
		l_score,
		s_score,
		r_score,
		w_score,
		org_id,
		product_id,
		product_name,
		grant_name,
		org_name,
		reviewAnswers,
	},
	elementType,
	setErrorMsg,
	currentAttemptId,
	courseId,
	fetchAttempt,
	fetchInstruction,
	setShowThankModal,
	showThankModal,
	userId,
	isRetail,
	attemptName,
	course_name,
	previewMode,
	product_id: productId,
	product_name: productName,
	elementName,
	containsEmail
}) => {
	let element_id =
		!!upNext && Object.entries(upNext).length > 0 ? upNext.element_id : '';

	const continueAction = () => {
		if (attemptName === 'freedailystep') {
			window.history.pushState(
				null,
				null,
				`${window.location.origin}/mydashboard`,
			);
			window.history.go();
		} else if (upNext?.lock_status) {
			setErrorMsg(upNext?.lock_message);
		} else {
			fetchInstruction(element_id, courseId);
		}
	};

	useEffect(() => {
		if (showThankModal && previewMode) {
			tagEvent({
				event: 'end_course_preview',
				user_id: userId,
				course_id: courseId,
				grant_name: course_name,
				product_id: productId,
				product_name: productName,
				platform: 'web',
				duration: Math.abs(
					dateDiff('seconds', localStorage.getItem('previewWebisodeStart')),
				),
				activity_name: elementName,
			});
			localStorage.removeItem('previewWebisodeStart');
		}
	}, [
		courseId,
		course_name,
		previewMode,
		productId,
		productName,
		product_id,
		product_name,
		showThankModal,
		userId,
		elementName,
	]);

	return (
		<Modal
			show={showThankModal}
			size="lg"
			dialogClassName="modal-90w"
			onHide={() => setShowThankModal(false)}
			backdrop="static"
			keyboard={false}
			className="thankyou-popup"
			id="thankyou-popup"
		>
			<Modal.Header>
				<h4 className="modal-title">
					{!!dailyStepImg && (
						<img
							src={`${Config.ASSETSPATH}img/dailytest_pink.png`}
							alt="daily step"
						/>
					)}
					Great! You finished the activity.
				</h4>
			</Modal.Header>
			<Modal.Body size="lg">
				<div className="row">
					<div className="col-lg-12 col-xs-12 text-center">
						{!!certImg && <p dangerouslySetInnerHTML={{ __html: certImg }} />}
						{!!attemptScore && containsEmail.indexOf('naanmudhalvan') === -1 && isRetail && (
							<p dangerouslySetInnerHTML={{ __html: attemptScore }} />
						)}
						{!certImg && <div className="popup-desc">Let’s keep going.</div>}
						{!!addToLinkedin && (
							<p
								onClick={() => {
									tagEvent({
										event: 'linkedin_share',
										user_id: userId,
										is_retail: isRetail,
										product_id,
										product_name,
										grant_name,
										org_id,
										org_name,
										score,
										l_score,
										s_score,
										r_score,
										w_score,
									});
								}}
								dangerouslySetInnerHTML={{ __html: addToLinkedin }}
							/>
						)}
						{!!element_id && courseId != 507 && (
							<Button
								aria-label="continue"
								className="btn-primarycol-centered"
								onClick={continueAction}
								style={{ cursor: 'pointer' }}
							>
								Continue
							</Button>
						)}
						{!!certLink && localStorage.getItem('active_course_id') !== '428' && (
							<p dangerouslySetInnerHTML={{ __html: certLink }} />
						)}

						{!!productPromo && Object.entries(productPromo).length > 0 && (
							<ProductPromo />
						)}
					</div>
				</div>
			</Modal.Body>

			<Modal.Footer>
				{/*!!reviewAnswers && localStorage.getItem('active_course_id') !== '428' && (
					<>
						<div className="footNote">You could also:</div>
						<div className="thankyou-popup-link">
							<span
								style={{ cursor: 'pointer' }}
								onClick={() => {
									fetchAttempt(currentAttemptId, true);
								}}
							>
								Review Answers
							</span>
						</div>
					</>
				)*/}
				{elementType !== 'D' ? (
					<div className="thankyou-popup-link">
						<a href="mycourse" style={{ cursor: 'pointer' }}>
							Back to My Course
						</a>
					</div>
				) : null}

				<TestInstruction />
				<ReviewAttemptModal />
			</Modal.Footer>
		</Modal>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchAttempt: (attemptId, review = false) =>
			dispatch(fetchAttempt({ attemptId, review })),
		fetchInstruction: (elementId, courseId, isReview = false) =>
			dispatch(fetchInstruction({ elementId, courseId, isReview })),
		setErrorMsg: (msg) => dispatch(setErrorMsg(msg)),
		setShowThankModal: (val) => dispatch(setShowThankModal(val)),
	};
};

const mapStateToProps = (state) => {
	const {
		thanksval,
		currentAttemptId,
		showThankModal,
		elementType,
		attemptName,
	} = state.rootReducer.testPageDetails;
	const {
		coursedetails: { course_name } = {},
		previewMode,
		elementName,
	} = state.rootReducer.myCourse;
	const {
		productData: { product_id, product_name } = {},
	} = state.rootReducer.buyCourse;
	//const { userId, isRetail, courseId } = state.rootReducer.loginDetails;

	const { userEmail, loginId, userId, isRetail, courseId } = state.rootReducer.loginDetails;
	const containsEmail = userEmail?.indexOf("@") !== -1 ? userEmail : loginId?.indexOf("@") !== -1 ? loginId : ''


	return {
		thanksval,
		courseId,
		currentAttemptId,
		showThankModal,
		attemptName,
		elementType,
		userId,
		isRetail,
		course_name,
		previewMode,
		product_id,
		product_name,
		elementName,
		containsEmail
	};
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(ThankYouModal);
